import styled from 'styled-components';

export const NewPasswordCont = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
